// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"UserManagementPage_actionButton__2gHsr","inputColActive":"UserManagementPage_inputColActive__1Uu55","checkBox":"UserManagementPage_checkBox__3XqhN"};